export default "__VITE_ASSET__CzE2d4LX__"